export const COLUMNS = [
  {
    Header: "Category",
    accessor: "Category"
  },
  {
    Header: "Code Name",
    accessor: "CodeName"
  },
  {
    Header: "Code Id",
    accessor: "CodeId"
  },
  {
    Header: "Code Description",
    accessor: "CodeDescription"
  },
  {
    Header: "Active",
    accessor: "Active",
    Cell: ({ cell }) => (cell.value ? "Yes" : "No")
  },
  {
    Header: "List Order",
    accessor: "ListOrder",
    Cell: ({ cell }) => cell.value
  }
];
